// notifications class
import { useContext, useEffect, useState } from 'react';
import StateContext from '../stateContext';
import axios from 'axios';

function Notifications() {
  const { notifications, deleteNotification } = useContext(StateContext);

  return (
    <section className='notifications'>
      {notifications.map((notification, index) => (
        <div key={index} onClick={() => { deleteNotification(index)}} className={notification.status == "success" ? "notificationSuccess" : "notificationError"}>{notification.msg}</div>
      ))}
    </section>
  )
}

export default Notifications